/*! Wi-pagination - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

+function ($) {
    'use strict';
    var wiPagination = window.wiPagination;
    window.wiPagination = {
        init: function () {
            $(document).on('click', '.pagination-item', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-id');
                var url = $(this).attr('data-href');
                wiPagination.get(id, url);
            });
            $(document).on('click', '.pagination-infinite', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-id');
                var url = $(this).attr('data-href');
                var btn = $(this).parent();
                wiPagination.infinite(id, url, btn);
            });
        },
        get: function (id, url) {
            wiLayout.loader('show');
            $.ajax({
                type: 'GET',
                url: url,
                success: function (data) {
                    if (id === 'app-projects') {
                        wiLayout.scroll.to($('#' + id));
                        $('#' + id).html(data);
                    } else {
                        wiLayout.scroll.to($('#' + id).parent());
                        $('#' + id).parent().html(data);
                    }
                    wiImages.refresh();
                    wiPlugins.refresh();
                    $(window).trigger('resize');
                    wiLayout.loader('remove');
                }
            });
        },
        infinite: function (id, url, btn) {
            wiLayout.loader('show');
            $.ajax({
                type: 'GET',
                url: url,
                success: function (response) {
                    btn.fadeOut('normal', function () {
                        $(this).remove();
                        $('#' + id).find('.infinity-items').append(response.html);
                        $('#' + id).attr('id', response.uid);
                        wiImages.refresh();
                        wiPlugins.refresh();
                        $(window).trigger('resize');
                        wiLayout.loader('remove');
                    });
                }
            });
        },
        refresh: function () {
        },
        events: function () {
        }
    };
    $(function () {
        wiPagination = window.wiPagination;
        wiPagination.init();
    });
}(jQuery);
